/* The Weglot app embed supplies the client library. Initialize that single
   copy once it is ready instead of loading a second copy of the library. */
(() => {
  if (window.__forgeWeglotInitRequested) return;

  window.__forgeWeglotInitRequested = true;
  const startedAt = window.performance.now();

  const initializeWeglot = () => {
    if (document.querySelector('.weglot-container.wg-default')) return;

    if (window.Weglot && typeof window.Weglot.initialize === 'function') {
      window.Weglot.initialize({
        api_key: 'wg_f2958ed83a42c877122bbe6047bcdb754'
      });
      return;
    }

    if (window.performance.now() - startedAt < 10000) {
      window.setTimeout(initializeWeglot, 50);
    }
  };

  initializeWeglot();
})();
